// extracted by mini-css-extract-plugin
export var editInput = "_gz-0";
export var editInputCompact = "_gz-2";
export var editInputLarge = "_gz-1";
export var editInputSmall = "_gz-3";